import { useCallback } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button/Button'

import { getFormedEltTranslation } from '../../../../helpers/getFormedEltTranslation'
import { Title } from '../../title/Title'

import styles from './ValueTypeConfirmDialogContent.module.scss'

interface IProps {
  onAgree: () => void
  closeDialog: () => void
}

export const ValueTypeConfirmDialogContent = ({ onAgree, closeDialog }: IProps) => {
  const onAgreeClick = useCallback(() => {
    closeDialog()
    onAgree()
  }, [onAgree, closeDialog])

  return (
    <div className={styles.root}>
      <Title align={'center'} text={getFormedEltTranslation('valueType-dialog-title')} />

      <div className={styles.text}>
        <Translation text={getFormedEltTranslation('valueType-dialog-text')} />
      </div>

      <div className={styles.buttonsWrapper}>
        <Button onClick={closeDialog} variant={'outlined'}>
          <Translation text={getFormedEltTranslation('valueType-dialog-cancel')} />
        </Button>
        <Button onClick={onAgreeClick} className={styles.saveButton}>
          <Translation text={getFormedEltTranslation('valueType-dialog-agree')} />
        </Button>
      </div>
    </div>
  )
}
